export default __webpack_public_path__ + "static/media/pictogramEFTPOS128.0080635a.svg";